/* eslint-disable react/no-unused-class-component-methods */
import * as React from 'react';
import './index.css';
import { connect } from '@wmfe/mach-pro-store';
import HeaderTitleNavBar from '@/src/pages/channel_list/header_view/components/title_nav_bar';
import HeaderImage from '@/src/pages/channel_list/header_view/components/header_image';
import { render } from 'react-dom';
import ChannelListScenceTab from '@/src/pages/channel_list/header_view/components/scene_tab';
import { FilterBarCommonTempID, HomePageMKTResource } from '@/src/pages/homepage/home_page_main/utils/constant';
import { isEqual } from 'lodash';
import {
  ChannelListHeaderImageTempID, ChannelListScenceTabTempID,
  COMPONENT_REF_TYPE,
  EVENT_NAME,
  RENDER_TYPE,
  ChannelListNavBarTempID
} from '../utils/constant';
import HeaderMKTResource from './components/HeaderMKTResource';

const mapStateToProps = () => ({});

type BaseIProps = ReturnType<typeof mapStateToProps>;

interface Props extends BaseIProps {
  moduleHeaderData: any;
  subBundles: { [id: string]: any; };
  onHeaderHeightChanged?: (frame: Frame, stickComponentsHeight: number, anchoringDistance: number) => void;
  isFullScreenPreheat?: boolean; // 是否为全屏兜底状态，此状态背景色为白色;
  externalStickHeaderContainerRef?: any;
  isHitPicCacheFFPAB?: boolean;
}

/**
 * 头部容器
 */
class SectionHeaderView extends React.Component<Props, any> {
  // Ref相关
  navRef?: any; // 地址栏Ref
  scenceRef?: any; // 搜索栏Ref
  filterRef?: any; // 筛排Ref
  // eslint-disable-next-line react/no-unused-class-component-methods
  // 给外部主包用的别删别删别删别删别删
  filterBarComponentRef?: any;
  // 滚动监听相关
  scrollObserver?: any;
  anchoringDistance = 0
  currentOffsetY = 0

  customComponentsConfig = {}
  constructor(props) {
    super(props);
    this.customComponentsConfig = {
      [ChannelListNavBarTempID]: HeaderTitleNavBar,
      [ChannelListHeaderImageTempID]: HeaderImage,
      [ChannelListScenceTabTempID]: ChannelListScenceTab,
      [HomePageMKTResource]: HeaderMKTResource
    };
  }

  componentDidMount(): void {
    // 计算筛排滑动到锚定点的距离（筛排上滑置顶的高度）
    const { statusBarHeight, navigationBarHeight } = Mach.env || {};
    this.anchoringDistance = Number(Mach.env?.screenWidth) / 375 * 211 - statusBarHeight - navigationBarHeight - 4;
    this.addSrollObserver();
  }

  componentWillUnmount(): void {
    this.removeSrollObserver();
  }

  componentWillReceiveProps(nextProps: Readonly<Props>): void {
    if (!isEqual({ ...nextProps.moduleHeaderData }, this.props.moduleHeaderData)) {
      this.headerComponentItems = {};
    }
  }

  /**
   * 注册滚动监听
   */
  addSrollObserver = () => {
    if (this.scrollObserver) {
      return;
    }

    // 滚动监听
    this.scrollObserver = globalThis.eventBus.subscribe(EVENT_NAME.ONSCROLL, (offset) => {
      this.onScroll(offset);
    });

    // 一键置顶监听
    this.scrollObserver = globalThis.eventBus.subscribe(EVENT_NAME.SCROLL_TO_TOP, () => {
      this.onScrollToTop();
    });
  }

  removeSrollObserver = () => {
    if (this.scrollObserver) {
      this.scrollObserver.unSubscribe();
      this.scrollObserver = undefined;
    }
  }

  /**
   * 一键置顶
   */
  onScrollToTop = () => {
    // 筛排器
    if (this.filterRef) {
      this.filterRef.style?.setProperty('background-image', 'transparent');
    }

    // 导航栏
    if (this.navRef) {
      this.navRef.style?.setProperty('transform', `translateY(${0})`);
      this.navRef.style?.setProperty('background-color', 'transparent');
    }

    // 场景Tab栏
    if (this.scenceRef) {
      this.scenceRef.style?.setProperty('transform', `translateY(${0})`);
      this.scenceRef.style?.setProperty('background-color', 'transparent');
    }
  }

  onStickStatusChanged = (componentItem: any, stickStatus: boolean) => {
    if (!componentItem) {
      return;
    }
    const { component_id, } = componentItem.data;
    if (stickStatus) {
      // 吸顶时的状态
      if (component_id === FilterBarCommonTempID) {
        componentItem.refs[COMPONENT_REF_TYPE.WRAPPER]?.style.setProperty('background-image', 'linear-gradient(180deg, #FFFFFF 0%, #F7F7F7 22%)');
      }
      if (component_id === ChannelListScenceTabTempID) {
        componentItem.refs[COMPONENT_REF_TYPE.WRAPPER]?.style.setProperty('background-color', '#ffffff');
      }
    } else {
      // 非吸顶时的状态
      if (component_id === FilterBarCommonTempID) {
        componentItem.refs[COMPONENT_REF_TYPE.WRAPPER]?.style?.setProperty('background-image', 'transparent');
        componentItem.refs[COMPONENT_REF_TYPE.WRAPPER]?.style?.setProperty('background-color', 'transparent');
      }
      if (component_id === ChannelListScenceTabTempID) {
        componentItem.refs[COMPONENT_REF_TYPE.WRAPPER]?.style?.setProperty('background-color', 'transparent');
      }
    }
  }

  /**
   * 滚动处理
   * @param offset
   */
  onScroll = (offset) => {
    if (!offset) {
      return;
    }
    this.currentOffsetY = offset.y;

    // 设置筛排器和场景Tab位置（上滑后锚定）

    let stickStatus = false;
    if (this.currentOffsetY >= this.anchoringDistance) {
      stickStatus = true;
      if (this.scenceRef) {
        this.scenceRef.style.setProperty('background-color', '#ffffff');
      }
    } else {
      if (this.scenceRef) {
        this.scenceRef.style.setProperty('background-color', 'transparent');
      }
    }

    // 吸顶组件处理
    const stickComponents = Object.values(this.headerComponentItems).filter((item: any) => item.stickType === 1);
    // 获取所有吸顶组件的高度
    stickComponents.forEach((item: any) => {
      this.onStickStatusChanged(item, stickStatus);
    });
  }

  headerComponentItems: { [key: string]: any; } = {}
  setItemRef = (item: any, refType: COMPONENT_REF_TYPE, ref?: any) => {
    if (!item) {
      return;
    }
    if (!ref) {
      return;
    }
    const { component_id, data_id, builder_id } = item;
    const key = `${component_id}_${data_id ?? ''}_${builder_id ?? ''}`;
    const componentItem = this.headerComponentItems[key];
    if (!componentItem) {
      const component_properties = item.component_properties || {};
      this.headerComponentItems[key] = {
        data: item,
        refs: {
          [refType]: ref
        },
        height: 0,
        stickType: component_properties?.stick_type || false,
        stickStaus: false
      };
    }
    this.headerComponentItems[key].refs[refType] = ref;
    if (refType === COMPONENT_REF_TYPE.INSTANCE && component_id === FilterBarCommonTempID) {
      // eslint-disable-next-line react/no-unused-class-component-methods
      // 给外部主包用的别删别删别删别删别删
      this.filterBarComponentRef = ref;
    }
  }

  setItemHeight = (item: any, height) => {
    if (!item) {
      return;
    }
    const { component_id, data_id, builder_id } = item;
    const key = `${component_id}_${data_id ?? ''}_${builder_id ?? ''}`;
    const componentItem = this.headerComponentItems[key];
    if (!componentItem) {
      return;
    }
    if (height > 0) {
      this.headerComponentItems.height = height;
    }
  }

  renderHeaderItem = (item: any) => {
    if (!item) {
      return null;
    }
    const { component_id } = item;
    const { subBundles } = this.props;
    let HeaderComponent = subBundles[component_id];
    if (item.component_properties?.render_type === RENDER_TYPE.CUSTOM) {
      HeaderComponent = this.customComponentsConfig[component_id];
    }

    if (HeaderComponent) {
      if (component_id === ChannelListNavBarTempID) {
        render(this.getHeaderElement(item, HeaderComponent), this.props.externalStickHeaderContainerRef);
        return null;
      }
      return this.getHeaderElement(item, HeaderComponent);
    } else {
      return null;
    }
  }

  private getHeaderElement(item: any, HeaderComponent) {
    const { layout_info } = item || {};
    const {
      margin_top, margin_bottom, margin_left, margin_right
    } = layout_info || {};
    const marginStyle = {
      marginTop: margin_top || 0,
      marginBottom: margin_bottom || 0,
      marginLeft: margin_left || 0,
      marginRight: margin_right || 0,
    };
    return (
      <view
        className="header-component-item-wrapper" ref={(ref) => {
          this.setItemRef(item, COMPONENT_REF_TYPE.WRAPPER, ref);
        }} style={{ backgroundColor: 'transparent', ...marginStyle }} onLayout={(frame) => { this.setItemHeight(item, frame.detail?.height); }}
      >
        <HeaderComponent
          wrappedComponentRef={(ref) => {
            this.setItemRef(item, COMPONENT_REF_TYPE.INSTANCE, ref);
          }} apiData={item}
        />
      </view>
    );
  }

  render() {
    const {
      moduleHeaderData, isFullScreenPreheat, isHitPicCacheFFPAB
    } = this.props;
    if (!moduleHeaderData || !moduleHeaderData.component_list || moduleHeaderData.component_list.length < 0) {
      return null;
    }
    const { component_list, layout_info, module_data } = moduleHeaderData;
    const {
      margin_top = 0, margin_bottom = 0, padding_top = 0, padding_bottom = 0
    } = layout_info || {};

    // 此处强制去重：避免出现上层数据错误导致吸顶组件异常的问题
    const componentList = component_list?.filter((item, index) => component_list.indexOf(item, 0) === index);
    const { module_bg_color } = module_data ?? {};
    const headerBgColor = module_bg_color ?? '#f7f7f7';

    return (
      <view
        className="header"
        style={{
          marginTop: margin_top,
          marginBottom: margin_bottom,
          paddingTop: padding_top,
          paddingBottom: padding_bottom,
          // 颜色：：这里决定 header 背景色
          backgroundColor: isFullScreenPreheat ? '#ffffff' : headerBgColor
        }}
        key={isHitPicCacheFFPAB ? 'sticky-key' : this.anchoringDistance}
        onLayout={(frame) => {
          const { onHeaderHeightChanged } = this.props;
          // 找到当前所有需要吸顶的组件
          const stickComponents = Object.values(this.headerComponentItems).filter((item: any) => item.stickType === 1);
          // 获取所有吸顶组件的高度
          let stickComponentsHeight = 0;
          stickComponents.forEach((item: any) => {
            const itemHeight = item.height || item.refs[COMPONENT_REF_TYPE.WRAPPER]?.measure?.().height || 0;
            stickComponentsHeight += itemHeight;
          });
          this.anchoringDistance = frame.detail.height - stickComponentsHeight;
          onHeaderHeightChanged?.(frame.detail, stickComponentsHeight, this.anchoringDistance);
        }}
      >
        {
          (componentList || []).map((item) => this.renderHeaderItem(item))
        }
      </view>
    );
  }
}

export default connect(mapStateToProps)(SectionHeaderView);
